import * as FluxUtils from 'flux/utils';
import * as Lockr from 'lockr';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { TooltipIds } from '../constants/TooltipIds';
import { AppConfigurationStore } from './AppConfigurationStore';
import { SidebarModule } from '../constants/Enums';

interface TooltipState {
    activeId: TooltipIds | null;
    shownTooltips: Array<TooltipIds>;
}

class TooltipStoreClass extends FluxUtils.ReduceStore<TooltipState, unknown> {
    public getInitialState(): TooltipState {
        const shownTooltips: Array<TooltipIds> = [
            TooltipIds.CATALOG_BUTTON_ON_STARTUP,
            TooltipIds.PROPERTY_PANEL_AFTER_ARTICLE_ADD,
            TooltipIds.CATALOG_FOLDER_ICON,
            TooltipIds.FLOORPLAN_ICON,
            TooltipIds.DRAW_WALL_ICON,
            TooltipIds.ARCHITECTURE_HINT
        ].filter((tooltipId) => {
            return Lockr.sismember('shownTooltips', tooltipId) as boolean;
        });
        return {
            activeId: null,
            shownTooltips: shownTooltips
        };
    }

    public reduce(state: TooltipState, action: DispatcherBaseAction): TooltipState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed
        switch (action.actionType) {
            case ActionConstants.SHOW_TOOLTIP:
                if (!this.wasShown(state.shownTooltips, action.value)) {
                    Lockr.sadd('shownTooltips', action.value);
                    return jQuery.extend(
                        {}, state, {activeId: action.value, shownTooltips: state.shownTooltips.concat([action.value])}
                    );
                }
                break;
            case ActionConstants.HIDE_TOOLTIP:
                return jQuery.extend({}, state, {activeId: null});

            // ----------------------------------------------------------------------
            // --- Special handling of different actions to show specific tooltip ---
            // ----------------------------------------------------------------------
            case ActionConstants.SHOW_SELECTBOX:
            case ActionConstants.SEARCH_CATALOG:
                return this.reduce(state, {actionType: ActionConstants.HIDE_TOOLTIP, value: null});
            case ActionConstants.CATALOG_UPDATE:
                // Show catalog-tooltip when catalog was updated first time (and no project-manager/room-wizard available)
                if (
                    !this.wasShown(state.shownTooltips, TooltipIds.CATALOG_BUTTON_ON_STARTUP)
                ) {
                    return this.reduce(state, {actionType: ActionConstants.SHOW_TOOLTIP, value: TooltipIds.CATALOG_BUTTON_ON_STARTUP});
                // Show catalog-folder-tooltip when 3rd catalog-folder is shown
                }
                if (action.value.catalogPath.length > 2 && !this.wasShown(state.shownTooltips, TooltipIds.CATALOG_FOLDER_ICON)) {
                    return this.reduce(state, {actionType: ActionConstants.SHOW_TOOLTIP, value: TooltipIds.CATALOG_FOLDER_ICON});
                }
                return this.reduce(state, {actionType: ActionConstants.HIDE_TOOLTIP, value: null});
            case ActionConstants.CHANGE_SIDEBAR:
                if (
                    AppConfigurationStore.getState().floorplanAvailable &&
                    action.value === SidebarModule.NONE &&
                    this.wasShown(state.shownTooltips, TooltipIds.PROPERTY_PANEL_AFTER_ARTICLE_ADD)
                ) {
                    return this.reduce(state, {actionType: ActionConstants.SHOW_TOOLTIP, value: TooltipIds.FLOORPLAN_ICON});
                }
                break;
            case ActionConstants.ARTICLE_ADDED:
                // Show property-editor-tooltip after an article was added
                return this.reduce(state, {actionType: ActionConstants.SHOW_TOOLTIP, value: TooltipIds.PROPERTY_PANEL_AFTER_ARTICLE_ADD});
            default:
                break;
        }
        return state;
    }

    protected wasShown(shownTooltips: Array<TooltipIds>, testId: TooltipIds): boolean {
        return shownTooltips.indexOf(testId) !== -1;
    }
}

export let TooltipStore: TooltipStoreClass = new TooltipStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/TooltipStore.ts